import { render, staticRenderFns } from "./video_box.vue?vue&type=template&id=4aba2c49&scoped=true&"
import script from "./video_box.vue?vue&type=script&lang=js&"
export * from "./video_box.vue?vue&type=script&lang=js&"
import style0 from "./video_box.vue?vue&type=style&index=0&id=4aba2c49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba2c49",
  null
  
)

export default component.exports